const te = {
  "भाजपा सदस्यता अभियान - 2024": "భాజపా సదస్యత అభియాన్ - 2024",
  "Select Language": "భాషను ఎంచుకోండి",
  Next: "తదుపరి",
  "Enter your mobile number": "మీ మొబైల్ నంబర్‌ను నమోదు చేయండి",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "నేను నిబంధనలు మరియు షరతులను అంగీకరిస్తున్నాను మరియు కొనసాగించడం ద్వారా స్వచ్ఛందంగా BJPలో సభ్యత్వం పొందడానికి నేను సమ్మతిస్తున్నాను",
  "Get OTP": "OTP పొందండి",
  "Terms and Conditions": "నిబంధనలు మరియు షరతులు",
  "You must tick the box to continue, as it is mandatory.":
    "కొనసాగించడానికి మీరు తప్పనిసరిగా పెట్టెలో టిక్ చేయాలి, ఎందుకంటే ఇది తప్పనిసరి.",
  "Okay, Got it": "సరే, అర్థమైంది",
  "Get OTP": "OTP పొందండి",
  "Enter OTP": "OTPని నమోదు చేయండి",
  "Resend OTP": "OTPని మళ్లీ పంపండి",
  Continue: "కొనసాగించు",
  "Fill details": "వివరాలను పూరించండి",
  "Upload Photo": "ఫోటోను అప్‌లోడ్ చేయండి",
  "Profile Photo": "ప్రొఫైల్ ఫోటో",
  "Mobile number": "మొబైల్ నంబర్",
  "Mrs.": "శ్రీమతి",
  "Mr.": "శ్రీ",
  Ms: "శ్రీమతి",
  "Full Name*": "పూర్తి పేరు *",
  "D.O.B": "D.O.B",
  Age: "వయస్సు",
  Gender: "లింగం",
  Female: "స్త్రీ",
  Male: "పురుషుడు",
  Other: "ఇతర",
  "Email Id": "ఇమెయిల్ ఐడి",
  "Add address": "చిరునామాను జోడించండి",
  "House/ Flat/ Floor No.": "ఇల్లు/ ఫ్లాట్/ ఫ్లోర్ నెం.",
  "Current address PIN code": "ప్రస్తుత చిరునామా పిన్ కోడ్",
  "District*": "జిల్లా*",
  State: "రాష్ట్రం",
  "Assembly constituency (AC)": "అసెంబ్లీ నియోజకవర్గం (AC)",
  "Tell us about your location": "మీ స్థానం గురించి మాకు చెప్పండి",
  "It will assist us in locating other members in your area.":
    "ఇది మీ ప్రాంతంలోని ఇతర సభ్యులను గుర్తించడంలో మాకు సహాయం చేస్తుంది.",
  "Your address as fetched": "మీ చిరునామా పొందినట్లు",
  "Referral code": "రెఫరల్ కోడ్",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "పైన అందించిన సమాచారం సరైనదేనని మరియు ఎటువంటి పొరపాటు లేదని నేను ధృవీకరిస్తున్నాను. పైన అందించిన వివరాలపై తదుపరి కమ్యూనికేషన్ అంతా జరుగుతుందని నాకు తెలుసు",
  Save: "సేవ్ చేయండి",
  Select: "ఎంచుకోండి",
  Camera: "కెమెరా",
  or: "లేదా",
  Gallery: "గ్యాలరీ",
  "Support format : Jpeg, Png, Pdf": "మద్దతు ఫార్మాట్: Jpeg, Png, Pdf",
  Cancel: "రద్దు చేయి",
  "Select location": "స్థానాన్ని ఎంచుకోండి",
  "Provide location": "స్థానాన్ని అందించండి",
  "Search results": "శోధన ఫలితాలు",
  "Search for a building, street name or..":
    "భవనం, వీధి పేరు లేదా.. కోసం శోధించండి.",
  "Your address as fetched": "మీ చిరునామా పొందినట్లు",
  "Locate me": "నన్ను గుర్తించు",
  "Confirm location": "స్థానాన్ని నిర్ధారించండి",
  "Congratulations !": "అభినందనలు !",
  "Your primary Id is -": "మీ ప్రాథమిక ఐడి -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "మీ డేటాను మెరుగుపరచడానికి, మీ ID కార్డ్‌ని యాక్సెస్ చేయడానికి మరియు ప్రాథమిక సభ్యులుగా చేరడానికి ఇతరులను సూచించడానికి Bjp.org/membershipకి లాగిన్ చేయండి.",
  "ID CARD": "ID కార్డ్",
  "You can download your generated ID Card":
    "మీరు రూపొందించిన మీ ID కార్డ్‌ని డౌన్‌లోడ్ చేసుకోవచ్చు",
  Download: "డౌన్‌లోడ్ చేయండి",
  "Go to dashboard": "డాష్‌బోర్డ్‌కి వెళ్లండి",
  "View your profile": "మీ ప్రొఫైల్‌ని వీక్షించండి",
  "Refer and add member": "సభ్యుడిని సూచించండి మరియు జోడించండి",
  Share: "షేర్ చేయండి",
  "To update your additional details and refer more member, please click here.":
    "మీ అదనపు వివరాలను నవీకరించడానికి మరియు మరింత మంది సభ్యులను సూచించడానికి, దయచేసి ఇక్కడ క్లిక్ చేయండి.",
  "Bharatiya Janata Party": "భారతీయ జనతా పార్టీ",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, దీనదయాళ్ ఉపాధ్యాయ మార్గ్, న్యూఢిల్లీ - 110002",
  Name: "పేరు",
  "Membership Number": "సభ్యత్వ సంఖ్య",
  "QR Code": "QR కోడ్",
  "Please select a year between 1930 and 2006.":
    "దయచేసి 1930 మరియు 2006 మధ్య సంవత్సరాన్ని ఎంచుకోండి.",
  "Please enter a valid email address.":
    "దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్ అడ్రస్ నమోదు చేయండి.",
  "Please enter 6-digit PIN code.": "దయచేసి 6-అంకెల పిన్ కోడ్‌ని నమోదు చేయండి.",
  "10-digit mobile number.": "10-అంకెల మొబైల్ నంబర్.",
  "Please enter a 10-digit mobile number.":
    "దయచేసి 10-అంకెల మొబైల్ నంబర్‌ను నమోదు చేయండి.",
  "Please enter your name.": "దయచేసి మీ పేరును నమోదు చేయండి.",
  "I pledge and willing to receive regular updates from BJP":
    "నేను బీజేపీ నుండి ఎప్పటికప్పుడు అప్‌డేట్‌లను స్వీకరించడానికి అంగీకరిస్తున్నాను.",
  "Get Verification Code": "వెరిఫికేషన్ కోడ్ ను పొందండి",
  "Enter Verification Code": "వెరిఫికేషన్ కోడ్ ను నమోదు చేయండి",
  "Resend Verification Code": "వెరిఫికేషన్ కోడ్ ను మరల పంపించండి",
  "Provide Details": "వివరాలు నమోదు చేయండి",
  Upload: "అప్లోడ్ చేయండి",
  Ok: "సరే",
  Calendar: "క్యాలెండర్",
  "Full Address": "పూర్తి చిరునామా",
  "Privacy policy": "గోప్యతా విధానాలు",
  Disclaimer: "డిస్క్లయిమర్",
  "Contact us": "మమ్మల్ని సంప్రదించండి",
  Save: "సేవ్ చేయండి",
  "Your primary member ID": "మీ ప్రాథమిక సభ్యత్వ ఐడీ",
  "Membership Card": "సభ్యత్వ కార్డు",
  "Your Unique Referral code": "మీ ప్రత్యేక రిఫరల్ కోడ్",
  "Invite and add member": "సభ్యుడిని ఆహ్వానించండి మరియు జోడించండి",
  Share: "షేర్ చేయండి",
  "Click below to add more details, donate and add other members to BJP":
    "మీ గురించి మరిన్ని వివరాలను పంచుకోవడానికి, విరాళాలు ఇవ్వడానికి మరియు ఇతర సభ్యులను బిజెపిలో చేర్చేందుకు క్రింద క్లిక్ చేయండి.",
  "Update your details": "మీ తాజా వివరాలను నమోదు చేయండి",
  "Add Referral Details": "రిఫరల్ వివరాలను జోడించండి",
  "Referred by (name)": "సూచించిన వారు (పేరు)",
  "Referred by (mobile number)": "సూచించిన వారు (మొబైల్ నంబర్)",
  Capture: "క్యాప్చర్",
  "Close Camera": "కెమెరా ను మూసివేయండి",
  Uploading: "అప్‌లోడ్ అవుతోంది",
  "Your Unique Referral Link": "మీ ప్రత్యేక రిఫరల్ లింక్",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "మీరు ఈరోజు OTP ప్రయత్నాలకు చేరుకున్నారు. దయచేసి రేపు మళ్లీ ప్రయత్నించండి.",
  Miss: "కుమారి",
  "Full Name": "పూర్తి పేరు",
  "OTP limit reached for today. Please try again tomorrow":
    "నేటికి OTP పరిమితిని చేరుకున్నారు. దయచేసి రేపు మళ్లీ ప్రయత్నించండి",
  ": is not a Primary Member, Only Primary Members can refer":
    ": ప్రాథమిక సభ్యుడు కాదు, ప్రాథమిక సభ్యులు మాత్రమే సూచించగలరు",
  "Please enter valid fullname":
    "దయచేసి చెల్లుబాటు అయ్యే పూర్తి పేరును నమోదు చేయండి",
  Upload: "అప్లోడ్ చేయండి",
};

export default te;
